import { createReducer } from 'typesafe-actions';
import { InitializationActions } from '../actions/initialization';

interface InitializationState {
    initialized: boolean;
}

const defaultState: InitializationState = { initialized: false };

export const initializationReducer = createReducer<InitializationState, InitializationActions>(
    defaultState,
).handleAction(InitializationActions.initializationSuccess, (state) => ({ ...state, initialized: true }));
